import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getProductFileContext } from "../../api/Design/productApi";
import TechnicalAttachmentsPanel from "../Design/TechnicalAttachmentsPanel";

export default function DesignTechnicalFilesDialog({
  open,
  onClose,
  productId,
  muestraId = null,
  muestraName = "",
  clientName = "",
  designLabel = "",
}) {
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !productId) {
      setContext(null);
      setError("");
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError("");

    getProductFileContext(productId)
      .then((data) => {
        if (!cancelled) setContext(data);
      })
      .catch((err) => {
        console.error("Error loading product file context:", err);
        if (!cancelled) {
          setError("No se pudo cargar el diseño vinculado a esta muestra.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, productId]);

  const title = context?.nombre || designLabel || "Ficheros técnicos";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 1,
          pr: 1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="overline" sx={{ opacity: 0.75, letterSpacing: 1 }}>
            {muestraId ? "Muestra" : "Diseño"}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
            {muestraName || title}
          </Typography>
          {muestraId && title ? (
            <Typography variant="caption" color="text.secondary">
              Diseño: {title}
            </Typography>
          ) : null}
        </Box>
        <IconButton onClick={onClose} size="small" aria-label="Cerrar">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 2 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : null}

        {error ? <Alert severity="error">{error}</Alert> : null}

        {!loading && !error && context ? (
          <TechnicalAttachmentsPanel
            productId={context.id}
            productName={context.nombre}
            temporada={context.temporada}
            marca={context.marca}
            designer={context.designer}
            clientName={clientName}
            muestras={
              muestraId
                ? [
                    {
                      ID_MUESTRA: muestraId,
                      MUESTRA: muestraName,
                      NombreCliente: clientName,
                    },
                  ]
                : []
            }
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
